import { toCamelCase } from "@/utils/utils";
import OrganizationsService from "@/api/services/organizations";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    invoiceLevels: () => () => {
      return ["store", "organization", "billing_entity"];
    },
    revenueRanges: () => () => {
      return ["0_to_250k", "250k_to_1M", "1M_to_5M", "5M_to_10M", "above_10M"];
    },
    networkTypes: () => () => {
      return ["independent", "network_franchises_branches", "branch_network"];
    },
  },
  mutations: {
    setIndex(state, index) {
      state.index = index;
    },
  },
  actions: {
    async fetchIndex(
      { commit },
      { page = 1, perPage = null, keywords = null, sources = [], invoiceResponsible = null } = {},
    ) {
      const response = await OrganizationsService.fetchIndex({ page, keywords, sources, perPage, invoiceResponsible });
      if (!response?.success) return response;

      const data = toCamelCase(response.data);
      commit("setIndex", data.organizations);

      return response;
    },

    async create(
      _,
      {
        name,
        businessName,
        billingAddress,
        networkType,
        revenueRange,
        registrationNumber,
        totalPointsOfSale,
        invoiceLevel,
        logoUrl,
      },
    ) {
      return await OrganizationsService.create({
        name,
        businessName,
        billingAddress,
        networkType,
        revenueRange,
        registrationNumber,
        totalPointsOfSale,
        invoiceLevel,
        logoUrl,
      });
    },

    async update(
      _,
      {
        id,
        name,
        businessName,
        billingAddress,
        totalPointsOfSale,
        logoUrl,
        invoiceLevel,
        revenueRange,
        iban,
        registrationNumber,
      },
    ) {
      return await OrganizationsService.update(id, {
        name,
        businessName,
        billingAddress,
        totalPointsOfSale,
        logoUrl,
        invoiceLevel,
        revenueRange,
        iban,
        registrationNumber,
      });
    },

    async fetch(_, { id, includes = [] }) {
      return await OrganizationsService.fetch(id, { includes });
    },
  },
};
